var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step"},[_c('NewQuestion',{attrs:{"questions":_vm.questions}}),_c('div',{staticClass:"container"},[_c('ExpandAll'),_c('SelfAnswer'),_c('BaseShowImg',{attrs:{"text":_vm.textButtonProcess,"src":_vm.user1}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }